<template>
  <Layout>
    <PageHeader :items="items" />
    <b-modal v-model="importModal" title="Import New Data" @ok="importQrData">
      <div v-if="isLoading == 1" class="text-center text-danger my-2">
        <b-spinner class="align-middle"></b-spinner>
        <strong>Please wait...</strong>
      </div>
      <div class="row">
        <div class="col-md-12 mb-2">
          <label class="form-label">Corporate Branch*</label>
          <multiselect
              v-model="corporateBranch"
              :options="corporateBranchArr"
              :show-labels="false"
              label="corpBranchName"
              track-by="corpBranchID"
          ></multiselect>
        </div>
        <div class="col-md-12 mb-2">
          <div class="file-upload-form">
            Choose File*
            <input
              accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              class="form-control"
              type="file"
              @change="getFile"
            />
          </div>
          <span class="text-muted"
            ><small
              >Note: Allowed file extensions : .csv,.xls,.xlsx . Max File Size
              Allowed : 2048 KB</small
            ></span
          >
        </div>
      </div>
    </b-modal>
    <!--FILTER START------>
    <div class="card" style="margin-top: -30px">
      <div class="card-body">
        <div class="inner mb-2 row">
          <!-- Country List-->
          <div class="col-md-2" style="width: 12%">
            <label>Country </label>
            <multiselect
              v-model="country"
              :options="countryArr"
              :show-labels="false"
              label="country"
              track-by="country"
              @input="getAllCities()"
            ></multiselect>
          </div>

          <div class="col-md-2" style="width: 12%">
            <label>City </label>
            <multiselect
              v-model="city"
              :options="cityArr"
              :show-labels="false"
              label="city"
              track-by="city"
              @input="getAllCompanies()"
            ></multiselect>
          </div>
          <div class="col-md-3">
            <label class="form-label" style="font-size: 12px"
              >Select Company
            </label>
            <multiselect
              v-model="companyID"
              :options="companyArr"
              :show-labels="false"
              label="companyName"
              track-by="companyID"
              @input="getRestaurantBrands()"
            ></multiselect>
          </div>
          <div class="col-md-2">
            <label class="form-label" style="font-size: 12px"
              >Select Restaurant Brand
            </label>
            <multiselect
              v-model="restID"
              :options="brandArr"
              :show-labels="false"
              label="name"
              track-by="restID"
              @input="getBranches()"
            ></multiselect>
          </div>
          <div class="col-md-3">
            <label>Restaurant Branch </label>
            <multiselect
              v-model="branchID"
              :options="restaurantBranches"
              :show-labels="false"
              label="branchName"
              track-by="restBranchID"
            ></multiselect>
          </div>
        </div>
        <div class="inner mb-2 row">
          <!-- Date range -->
          <div class="col-md-3">
            <label>Date Range </label>
            <date-picker
              v-model="daterange"
              append-to-body
              confirm
              format="DD MMM Y"
              lang="en"
              value-type="format"
              range
            ></date-picker>
          </div>

          <!-- Order Type END-->

          <!-- Apply filter -->
          <div class="col-md-3" style="width: auto; margin-top: auto">
            <button class="btn btn-themeOrange mt-4" v-on:click="applyFilter()">
              Apply Filter
            </button>
          </div>
          <!-- Apply filter END-->

          <!-- Clear filter -->
          <div class="col-md-3">
            <button class="btn btn-themeBrown mt-4" v-on:click="clearFilter()">
              Clear Filter
            </button>
          </div>
          <div class="col-md-3 mt-4">
            <button
              class="btn btn-themeYellow float-end"
              @click="importModal = !importModal"
            >
              <i class="uil-plus"></i> Import Data
            </button>
          </div>
          <!-- Clear filter END-->
        </div>
      </div>
    </div>
    <!--FILTER END------>

    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <div v-if="loading == 1" class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading Please wait...</strong>
          </div>
          <b-tabs
            content-class="p-3 text-muted"
            justified
            nav-class="nav-tabs-custom"
          >
            <b-tab active>
              <template v-slot:title>
                <span class="d-inline-block d-sm-none">
                  <i class="far fa-user"></i>
                </span>
                <span class="d-none d-sm-inline-block">SmartWorks Sales</span>
              </template>
              <div class="col-12">
                <div class="card">
                  <div class="card-body">
                    <div class="row mt-4">
                      <div
                        class="col-sm-12 col-md-4"
                        style="margin-bottom: 5px"
                      >
                        <div class="btn-group" role="group">
                          <button
                            v-if="$can('download qr sales report')"
                            class="btn btn-themeBrown"
                            type="button"
                            @click="downloadSample()"
                          >
                            Download Excel
                          </button>
                        </div>
                      </div>
                      <div class="col-sm-12 col-md-4 ">
                        <div
                          id="tickets-table_length"
                          class="dataTables_length"
                        >
                          <label class="d-inline-flex align-items-center">
                            Show &nbsp;&nbsp;
                            <b-form-select
                              v-model="perPage"
                              :options="pageOptions"
                              size="sm"
                              style="margin-left: 5px; margin-right: 5px"
                              @input="getTransactions(1)"
                            ></b-form-select
                            >&nbsp;&nbsp;&nbsp; entries
                          </label>
                        </div>
                      </div>
                    </div>
                    <!-- Table -->
                    <div class="table-responsive mb-0">
                      <b-table
                        :busy="isReportTableBusy"
                        :fields="fields"
                        :filter="filter"
                        :filter-included-fields="filterOn"
                        :items="tableItems"
                        :per-page="0"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                        bordered
                        hover
                        outlined
                        responsive
                        striped
                      >
                        <template #table-busy>
                          <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Loading...</strong>
                          </div>
                        </template>
                      </b-table>
                    </div>
                    <div class="row">
                      <div class="col">
                        <div
                          class="
                            dataTables_paginate
                            paging_simple_numbers
                            float-end
                          "
                        >
                          <ul class="pagination pagination-rounded mb-0">
                            <b-pagination
                              v-model="currentPage"
                              :per-page="tableTo"
                              :total-rows="tableTotal"
                              size="md"
                            ></b-pagination>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config.json";
import Multiselect from "vue-multiselect";
import DatePicker from "vue2-datepicker";
import { authHeader } from "@/helpers/fakebackend/auth-header";

export default {
  name: "SmartWorksSales",
  page: {
    title: "SmartWorks Sales",
    meta: [
      {
        name: "description",
        content: appConfig.description
      }
    ]
  },
  components: { Layout, PageHeader, Multiselect, DatePicker },
  data() {
    return {
      isReportTableBusy: false,
      tableData: [],
      tableTotal: "",
      tableTo: "",
      tableItems: [],
      tableExcelData: [],
      title: "SmartWorks Sales",
      items: [
        {
          text: "View"
        },
        {
          text: "SmartWorks Sales",
          active: true
        }
      ],
      importModal: false,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 500, 1000, 2000, "All"],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      daterange: [],
      restaurantBranches: [],
      branchID: "",
      cityArr: [],
      city: "",
      countryArr: [],
      country: "",
      companyArr: [],
      companyID: "",
      brandArr: [],
      restID: "",
      popupBranches: [],
      popupBranch: "",
      isLoading: 0,
      loading: 0,
      encodeDocument: "",
      fields: [
        {
          key: "corporate_branch_code",
          sortable: true,
          tdClass: "align-right",
          label: "Corporate Branch Code"
        },
        {
          key: "sw_id",
          sortable: true,
          tdClass: "align-right",
          label: "SW ID"
        },
        {
          key: "location_name",
          sortable: true,
          tdClass: "align-right",
          label: "Location"
        },
        {
          key: "store_name",
          sortable: true,
          tdClass: "align-right",
          label: "Store Name"
        },
        {
          key: "restaurant_type",
          sortable: true,
          tdClass: "align-right",
          label: "Restaurant Type"
        },
        {
          key: "legal_name",
          sortable: true,
          tdClass: "align-right",
          label: "Legal Name"
        },
        {
          key: "date",
          label: "Date",
          sortable: true
        },
        {
          key: "day",
          label: "Day",
          sortable: true
        },
        {
          key: "total_orders",
          label: "Total Orders",
          sortable: true
        },
        {
          key: "total_sales",
          label: "Total Sales",
          sortable: true
        },
        {
          key: "validated",
          label: "Validated",
          sortable: true
        },
        {
          key: "razorpay",
          label: "RazorPay",
          sortable: true
        },
        {
          key: "paytm_dqr",
          label: "Paytm Dqr",
          sortable: true
        },
        {
          key: "points_wallet",
          label: "Wallet points",
          sortable: true
        },
        {
          key: "b2b",
          label: "B2B (Rs.)",
          sortable: true
        },
        {
          key: "cb_applied",
          label: "CB Applied (Rs.)",
          sortable: true
        },
        {
          key: "b2c",
          label: "B2C (Rs.)",
          sortable: true
        },
        {
          key: "offline",
          label: "Manual/Offline",
          sortable: true
        },
        {
          key: "taxable_amount",
          label: "Taxable Amount",
          sortable: true
        },
        {
          key: "cgst_rate",
          label: "CGST Rate",
          sortable: true
        },
        {
          key: "cgst_amount",
          label: "CGST Amount",
          sortable: true
        },
        {
          key: "sgst_rate",
          label: "SGST Rate",
          sortable: true
        },
        {
          key: "sgst_amount",
          label: "SGST Amount",
          sortable: true
        },
        {
          key: "total_tax",
          label: "Total Tax",
          sortable: true
        },

      ],
      corporateBranchArr:[],
      corporateBranch:"",
    };
  },
  mounted() {
    this.totalRows = this.items.length;
    this.getAllCountry();
  },
  computed: {
    rows() {
      return this.tableItems.length;
    }
  },
  watch: {
    currentPage: function(newVal) {
      this.viewSalesReportPerPage(newVal);
    },
    importModal : function(){
      if(this.importModal==true && this.corporateBranchArr.length==0){
        this.getCorporateBranchList();
      }
    }
  },
  methods: {
    getAllCountry() {
      this.loading = 1;
      this.countryArr = [];
      this.country = "";
      this.axios
        .post(this.$loggedRole+"/getAllCountry", {
          empTypeID: this.$storageData.profile.empTypeID,
          empID: this.$storageData.profile.pid,
          loginTypeID: this.$storageData.login_type
        })
        .then(response => {
          this.loading = 0;
          this.countryArr = response.data.data;
        })
        .catch(error => {
          this.loading = 0;
          this.$swal({
            icon: "error",
            title: "Oops...",
            text:error.response.data.message
          });
        });
    },
    getAllCities() {
      this.loading = 1;
      this.axios
        .post(this.$loggedRole+"/getAllCities", {
          country: this.country ? this.country.country : "",
          empTypeID: this.$storageData.profile.empTypeID,
          empID: this.$storageData.profile.pid,
          loginTypeID: this.$storageData.login_type
        })
        .then(response => {
          this.loading = 0;
          this.cityArr = response.data.data;
        })
        .catch(error => {
          this.loading = 0;
          this.$swal({
            icon: "error",
            title: "Oops...",
            text:error.response.data.message
          });
        });
    },
    getAllCompanies() {
      this.loading = 1;
      this.companyArr = [];
      this.companyID = "";
      this.axios
        .post(this.$loggedRole+"/getAllCompanies", {
          country: this.country ? this.country.country : "",
          city: this.city ? this.city.city : "",
          empTypeID: this.$storageData.profile.empTypeID,
          empID: this.$storageData.profile.pid,
          loginTypeID: this.$storageData.login_type
        })
        .then(response => {
          this.loading = 0;
          this.companyArr = response.data.data;
        })
        .catch(error => {
          this.loading = 0;
          this.$swal({
            icon: "error",
            title: "Oops...",
            text:error.response.data.message
          });
        });
    },
    getRestaurantBrands() {
      this.loading = 1;
      this.axios
        .post(this.$loggedRole+"/getRestaurantBrandsByCompanyID", {
          companyID: this.companyID,
          empTypeID: this.$storageData.profile.empTypeID,
          empID: this.$storageData.profile.pid,
          loginTypeID: this.$storageData.login_type
        })
        .then(response => {
          this.loading = 0;
          this.brandArr = response.data.data;
        })
        .catch(error => {
          this.loading = 0;
          this.$swal({
            icon: "error",
            title: "Oops...",
            text:error.response.data.message
          });
        });
    },
    getBranches() {
      if (this.country.length == 0 || this.country == "undefined") {
        this.$swal({
          icon: "error",
          title: "Oops...",
          text:"Please select country."
        });
      } else if (this.city.length == 0 || this.city == "undefined") {
        this.$swal({
          icon: "error",
          title: "Oops...",
          text:"Please select city."
        });

      } else if (this.restID.length == 0 || this.restID == "undefined") {
        this.$swal({
          icon: "error",
          title: "Oops...",
          text: "Please select restaurant brand."
        });

      } else {
        this.loading = 1;
        this.axios
          .post(this.$loggedRole+"/sw-sales/get-restaurant-branch", {
            restaurant_id: this.restID.restID,
            empTypeID: this.$storageData.profile.empTypeID,
            city: this.city ? this.city.city : "",
            country: this.country ? this.country.country : "",
            empID: this.$storageData.profile.pid,
            loginTypeID: this.$storageData.login_type
          })
          .then(response => {
            this.loading = 0;
            if (response.data.status == 200) {
              this.restaurantBranches = response.data.data;
            } else {
              this.$swal({
                icon: "error",
                title: "Oops...",
                text: response.data.message
              });

            }
          })
          .catch(error => {
            this.loading = 0;
            this.$swal({
              icon: "error",
              title: "Oops...",
              text:error.response.data.message
            });
          });
      }
    },
    getFile: function(event) {
      var input = event.target;
      if (input.files && input.files[0]) {
        this.encodeDocument = input.files[0];
      }
    },
    importQrData(e) {
      e.preventDefault();
      this.isLoading = 1;
      let formData = new FormData();
      formData.append("corporate_branch_id", this.corporateBranch.corpBranchID);
      formData.append("uploaded_doc", this.encodeDocument);
      formData.append("employee_id", this.$storageData.profile.pid);
      let headers = authHeader();
      headers["Content-Type"] = "multipart/form-data";
      this.axios
        .post(this.$loggedRole+"/sw-sales/import-data", formData, { headers })
        .then(response => {
          this.isLoading = 0;
          this.importModal = !this.importModal;
          if (response.data.status == 200) {
            this.$swal({
              icon: "success",
              title: "Data Import",
              text: response.data.message
            });
          } else {
            this.$swal({
              icon: "error",
              title: "Oops...",
              text: response.data.message
            });
          }
        })
        .catch(error => {
          this.isLoading = 0;
          this.$swal({
            icon: "error",
            title: "Oops...",
            text: error.response.data.message
          });
        });
    },
    applyFilter() {
      this.getTransactions(1);
    },
    viewSalesReportPerPage(currentPage) {
      this.getTransactions(currentPage);
    },
    clearFilter() {
      this.tableData = [];
      this.tableTotal = "";
      this.tableTo = "";
      this.tableItems = [];
      this.filterOn = [];
      this.daterange = [];
      this.restaurantBranches = [];
      this.branchID = "";
      this.cityArr = [];
      this.city = "";
      this.country = "";
      this.companyArr = [];
      this.companyID = "";
      this.brandArr = [];
      this.restID = "";
      this.tableExcelData = [];
    },
    getTransactions(page) {
      this.loading = 1;
      this.isReportTableBusy = true;
      this.axios
        .post(this.$loggedRole+"/sw-sales/get-sw-sales?page=" + page, {
          empTypeID: this.$storageData.profile.empTypeID,
          empID: this.$storageData.profile.pid,
          restaurant_branch_id:
            this.branchID !== null ? this.branchID.restBranchID : "",
          restaurant_id: this.restID !== null ? this.restID.restID : "",
          company_id: this.companyID !== null ? this.companyID.companyID : "",
          daterange: this.daterange,
          loginTypeID: this.$storageData.login_type,
          perPage: this.perPage,
          country: this.country ? this.country.country : "",
          city: this.city ? this.city.city : ""
        })
        .then(response => {
          this.loading = 0;
          this.isReportTableBusy = false;
          if (response.data.status == 200) {
            if (this.perPage != "All") {
              if (page === 1) {
                this.tableData = response.data;
                this.tableTotal = this.tableData.data.total;
                this.tableTo = this.tableData.data.to;
              }
              this.tableExcelData = this.tableItems = response.data.data.data;
            } else {
              this.tableExcelData = this.tableItems = response.data.data;
              this.tableTotal = 1;
              this.tableTo = 1;
            }
          } else {
            this.$swal({
              icon: "error",
              title: "Oops...",
              text:response.data.message
            });

          }
        })
        .catch(error => {
          this.loading = 0;
          this.isReportTableBusy = false;
          this.$swal({
            icon: "error",
            title: "Oops...",
            text:error.response.data.message
          });
        });
    },
    downloadSample() {
      this.isLoading = 1;
      this.axios
        .post(this.$loggedRole+"/exportExcel",
          {
            exportData: this.tableExcelData,
            page: "SmartWorksSales"
          },
          {
            responseType: "blob"
          }
        )
        .then(response => {
          this.isLoading = 0;
          const url = URL.createObjectURL(
            new Blob([response.data], {
              type: "application/vnd.ms-excel"
            })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "smartworks-sales.xlsx");
          document.body.appendChild(link);
          link.click();
        });
    },
    getCorporateBranchList(){
      this.isLoading = 1;
      this.corporateBranchArr = [];
      this.corporateBranch = "";
      this.axios.get(this.$loggedRole+"/getCorporateBranchList"
      )
          .then(response => {
            this.isLoading=0;
            this.corporateBranchArr = response.data.data;
          })
          .catch((error)=>{
            this.isLoading=0;
            this.$swal({
              icon:"error",
              text:error.response.data.message,
            });
          });
    },
  }
};
</script>

<style scoped></style>
